import React, { useRef, useEffect } from 'react';
import { Modal, Typography, Divider } from 'antd';
import dayjs from 'dayjs';
import { Viewer } from '@toast-ui/react-editor';
import { Editor as TuiViewerCore } from '@toast-ui/editor/types/editor';
import { Notice } from '../../../Modules/Notice/Model/Notice';
import { useAppSelector } from '../../../Modules/Presentation/hooks';
import { selectAccounts } from '../../../Modules/Account/Presentation/selectors';
import { getAccountNameById } from '../../../Utils/getAccountNameById';
import { selectUser } from '../../../Modules/User/Presentation/selectors';

const { Text } = Typography;

interface Props { notice: Notice | null; open: boolean; onClose: () => void }

const NoticeViewModal: React.FC<Props> = ({ notice, open, onClose }) => {
  const accounts = useAppSelector(selectAccounts);
  const viewerRef = useRef<Viewer>(null);
  const currentUser = useAppSelector(selectUser);

  /* notice 가 바뀔 때마다 Viewer 내용 갱신 */
  useEffect(() => {
    if (notice && viewerRef.current) {
      (viewerRef.current.getInstance() as TuiViewerCore).setMarkdown(notice.content || '');
    }
  }, [notice]);

  return (
    <Modal
      title={notice?.title ?? '공지 보기'}
      open={open}
      footer={null}
      onCancel={onClose}
      width={800}
    >
      {notice && (
        <>
          <Text type="secondary">
            작성일: {dayjs(notice.created_at).format('YYYY-MM-DD')} |
            작성자: {getAccountNameById(accounts, notice.authorId, false, currentUser)}
          </Text>
          <Divider />
          <Viewer ref={viewerRef} initialValue={notice.content} />
        </>
      )}
    </Modal>
  );
};

export default NoticeViewModal;
